global.platformURI = process.env.REACT_APP_BASE_URL || "https://be-api-staging.censioanalytics.com";
// global.platformURI = "https://fe2f-103-180-81-206.ngrok-free.app"
// global.platformURI = "http://172.16.16.95:3001";
// global.platformURI = "https://app-api.censioanalytics.com";
